<template>

  <header id="page-topbar" >
    <div class="navbar-header">
      <div class="d-flex">
        <HederLogo single />
        <BButton type="button" 
                 class="btn btn-sm px-3 font-size-16 d-none d-md-inline-block d-lg-none header-item bg-transparent" 
                 aria-label="Otvori meni"
               data-toggle="collapse" 
               data-target="#topnav-menu-content" 
               @click="toggleMenu">
          <i class="esei icon-bars"></i>
        </BButton>
        <app-search/>
      </div>

      <!-- telefon: zeleno "+" (dodaj oglas) na sredini zaglavlja -->
      <NuxtLink to="/korisnicki-profil/novi-oglas" class="mh-add" aria-label="Dodaj oglas" title="Dodaj oglas">
        Dodaj<br>oglas
      </NuxtLink>

      <div class="d-flex">
     
        

        <Notifications  />

        <Profile />

        <div class="dropdown d-inline-block" v-if="false">
          <BButton type="button" class="btn header-item noti-icon right-bar-toggle toggle-right" @click="toggleRightSidebar">
            <i class="uil-cog toggle-right"></i>
          </BButton>
        </div>
      </div>
    </div>
    <!-- telefon: traka sa tekstom ispod zaglavlja; "Meni" otvara pun meni -->
    <MobileTabs @menu="toggleMenu" />
    <MenuComponent />
  </header>
</template>
<script setup>

 
import { useRoute, useRouter } from 'vue-router'
import HederLogo from '~/components/layouts/common/HeaderLogo.vue'
import AppSearch from '~/components/layouts/common/AppSearch.vue'
import { BButton } from 'bootstrap-vue-next';
import Notifications from '~/components/layouts/common/Notifications.vue'
import Profile from '~/components/layouts/common/Profile.vue'
import MenuComponent from '~/components/layouts/horizontal/MenuComponent.vue'
import MobileTabs from '~/components/layouts/common/MobileTabs.vue'

const props = defineProps({
  type: {
    type: String,
    required: true
  },
  width: {
    type: String,
    required: true
  }
})

const router = useRouter()
onMounted(() => {
  activateParentDropdown()

  router.afterEach(() => {
    activateParentDropdown()
  })
})

// Watcheri (ako aktiviraš komentare)
watch(
  () => props.type,
  (newVal, oldVal) => {
    // Dodaj logiku ako želiš da reaguješ na promene `type`
  },
  { immediate: true }
)

watch(
  () => props.width,
  (newVal, oldVal) => {
    // Dodaj logiku ako želiš da reaguješ na promene `width`
  },
  { immediate: true }
)

// Metode
const _removeAllClass = (className) => {
  const els = document.getElementsByClassName(className)
  while (els[0]) {
    els[0].classList.remove(className)
  }
}

const activateParentDropdown = () => {
  const resetParent = (el) => {
    const parent = el.parentElement
    _removeAllClass('mm-active')
    _removeAllClass('mm-show')
    if (parent) {
      parent.classList.remove('active')
      const parent2 = parent.parentElement
      if (parent2) {
        parent2.classList.remove('active')
        const parent3 = parent2.parentElement
        if (parent3) {
          parent3.classList.remove('active')
          const parent4 = parent3.parentElement
          if (parent4) {
            parent4.classList.remove('active')
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.remove('active')
              const menuelement = document.getElementById('topnav-menu-content')
              if (menuelement?.classList.contains('show')) {
                menuelement.classList.remove('show')
              }
            }
          }
        }
      }
    }
  }

  const links = document.getElementsByClassName('side-nav-link-ref')
  let matchingMenuItem = null
  for (let i = 0; i < links.length; i++) {
    resetParent(links[i])
  }

  for (let i = 0; i < links.length; i++) {
    if (window.location.pathname === links[i].pathname) {
      matchingMenuItem = links[i]
      break
    }
  }

  if (matchingMenuItem) {
    matchingMenuItem.classList.add('active')
    let parent = matchingMenuItem.parentElement
    if (parent) {
      parent.classList.add('active')
      const parent2 = parent.parentElement
      if (parent2) parent2.classList.add('active')
      const parent3 = parent2?.parentElement
      if (parent3) {
        parent3.classList.add('active')
        const childAnchor = parent3.querySelector('.has-dropdown')
        if (childAnchor) childAnchor.classList.add('active')
      }
      const parent4 = parent3?.parentElement
      if (parent4) parent4.classList.add('active')
      const parent5 = parent4?.parentElement
      if (parent5) parent5.classList.add('active')
    }
  }
}

const initFullScreen = () => {
  const doc = document.documentElement
  if (!document.fullscreenElement &&
    !document.mozFullScreenElement &&
    !document.webkitFullscreenElement
  ) {
    if (doc.requestFullscreen) doc.requestFullscreen()
    else if (doc.mozRequestFullScreen) doc.mozRequestFullScreen()
    else if (doc.webkitRequestFullscreen) doc.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT)
  } else {
    if (document.cancelFullScreen) document.cancelFullScreen()
    else if (document.mozCancelFullScreen) document.mozCancelFullScreen()
    else if (document.webkitCancelFullScreen) document.webkitCancelFullScreen()
  }
}

const toggleRightSidebar = () => {
  // Ako koristiš emit, zameni sa `emit('toggleRightSidebar')`
}

const onMenuClick = (event) => {
  event.preventDefault()
  const nextEl = event.target.nextElementSibling
  if (nextEl) {
    const parentEl = event.target.parentNode
    if (parentEl) parentEl.classList.remove('show')
    nextEl.classList.toggle('show')
  }
  return false
}

const toggleMenu = () => {
   
  
  const element = document.getElementById('topnav-menu-content')
   

  element?.classList.toggle('show')
}


</script>

<!-- 
<script>
import { LanguagesWithFlag } from "~/components/layouts/utils/topBar.js";
import HederLogo from "~/components/layouts/common/HeaderLogo.vue";
import AppSearch from "~/components/layouts/common/AppSearc.vue";
import MobileAppSearch from "~/components/layouts/common/MobileAppSearch.vue";
import LanguageDropdown from "~/components/layouts/common/LanguageDropdown.vue";
import AppList from "~/components/layouts/common/AppList.vue";
import Notifications from "~/components/layouts/common/Notifications.vue";
import Profile from "~/components/layouts/common/Profile.vue";
import MenuComponent from "~/components/layouts/horizontal/MenuComponent.vue";

// import { layoutComputed, authFackMethods } from "~/store/helpers";
import { BButton } from 'bootstrap-vue-next';

export default {
  data() {
    return {
      languages: LanguagesWithFlag,
      current_language: 'en',
      text: null,
      flag: null,
      value: null
    };
  },
  components: {
    HederLogo,
    AppSearch,
    MobileAppSearch,
    LanguageDropdown,
    AppList,
    Notifications,
    Profile,
    MenuComponent
  },
  props: {
    type: {
      type: String,
      required: true
    },
    width: {
      type: String,
      required: true
    }
  },
  computed: {
    // ...layoutComputed
  },
  mounted() {
    this.value = this.languages.find((x) => x.language === 'en');
    this.text = this.value.title;
    this.flag = this.value.flag;
    this.activateParentDropdown();

    this.$router.afterEach((routeTo, routeFrom) => {
      this.activateParentDropdown();
    });
  },
  methods: {
    // ...authFackMethods,
    _removeAllClass(className) {
      const els = document.getElementsByClassName(className);
      while (els[0]) {
        els[0].classList.remove(className);
      }
    },

    activateParentDropdown() {
      const resetParent = (el) => {
        const parent = el.parentElement;
        this._removeAllClass("mm-active");
        this._removeAllClass("mm-show");
        if (parent) {
          parent.classList.remove("active");
          const parent2 = parent.parentElement;
          if (parent2) {
            parent2.classList.remove("active");
            const parent3 = parent2.parentElement;
            if (parent3) {
              parent3.classList.remove("active");
              const parent4 = parent3.parentElement;
              if (parent4) {
                parent4.classList.remove("active");
                const parent5 = parent4.parentElement;
                if (parent5) {
                  parent5.classList.remove("active");
                  const menuelement = document.getElementById(
                    "topnav-menu-content"
                  );
                  if (menuelement !== null)
                    if (menuelement.classList.contains("show"))
                      document
                        .getElementById("topnav-menu-content")
                        .classList.remove("show");
                }
              }
            }
          }
        }
      };
      var links = document.getElementsByClassName("side-nav-link-ref");
      var matchingMenuItem = null;
      for (let i = 0; i < links.length; i++) {
        // reset menu
        resetParent(links[i]);
      }
      for (var i = 0; i < links.length; i++) {
        if (window.location.pathname === links[i].pathname) {
          matchingMenuItem = links[i];
          break;
        }
      }
      if (matchingMenuItem) {
        matchingMenuItem.classList.add("active");
        var parent = matchingMenuItem.parentElement;
        if (parent) {
          parent.classList.add("active");
          const parent2 = parent.parentElement;
          if (parent2) {
            parent2.classList.add("active");
          }
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add("active");
            var childAnchor = parent3.querySelector(".has-dropdown");
            if (childAnchor) childAnchor.classList.add("active");
          }

          const parent4 = parent3.parentElement;
          if (parent4) parent4.classList.add("active");
          const parent5 = parent4.parentElement;
          if (parent5) parent5.classList.add("active");
        }
      }
    },
    /**
     * Full-screen
     */
    initFullScreen() {
      //document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */
        !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    onMenuClick(event) {
      event.preventDefault();
      const nextEl = event.target.nextElementSibling;
      if (nextEl) {
        const parentEl = event.target.parentNode;
        if (parentEl) {
          parentEl.classList.remove("show");
        }
        nextEl.classList.toggle("show");
      }
      return false;
    },

    /**
     * Language set
     */
    setLanguage(data) {
      const { language, country, flag } = data;
      this.current_language = language;
      this.text = country;
      this.flag = flag;
    },
    toggleMenu() {
      let element = document.getElementById("topnav-menu-content");
      element.classList.toggle("show");
    },
    logoutUser() {
      this.$router.push({
        path: "/login"
      });
    }
  },
  watch: {
    type: {
      immediate: true,
      handler(newVal, oldVal) {
        // if (newVal !== oldVal) {
        //   switch (newVal) {
        //     case "dark":
        //       document.body.setAttribute("data-topbar", "dark");
        //       break;
        //     case "light":
        //       document.body.setAttribute("data-topbar", "light");
        //       document.body.removeAttribute("data-layout-size", "boxed");
        //       break;
        //     case "colored":
        //       document.body.setAttribute("data-topbar", "colored");
        //       document.body.removeAttribute("data-layout-size", "boxed");
        //       break;
        //     default:
        //       document.body.setAttribute("data-topbar", "dark");
        //       break;
        //   }
        // }
      }
    },
    width: {
      immediate: true,
      handler(newVal, oldVal) {
        // if (newVal !== oldVal) {
        //   switch (newVal) {
        //     case "boxed":
        //       document.body.setAttribute("data-layout-size", "boxed");
        //       break;
        //     case "fluid":
        //       document.body.setAttribute("data-layout-mode", "fluid");
        //       document.body.removeAttribute("data-layout-size");
        //       break;
        //     default:
        //       document.body.setAttribute("data-layout-mode", "fluid");
        //       break;
        //   }
        // }
      }
    }
  }
};
</script> -->


